<template lang="html">
  <div>
    <el-card v-if="!isSimplify">
      <div class="card-content">
        <!-- 左側區域 -->
        <div class="left-section">
          <el-cascader
            v-if="!isKMRT"
            v-model="instruments"
            style="min-width:300px"
            ref="cascader"
            filterable
            clearable
            :options="instrumentOptions"
            :props="props"
            :collapse-tags="true"
            :show-all-levels="false"
            :placeholder="$t('chart.instrument.pick')"
            @change="getCascaderInstrumentList"
          ></el-cascader>
          <span v-else>
            <div class="is-pulled-right">
              <el-button
                v-for="option in pickDateList"
                :key="option.value"
                :class="{ 'is-plain': dateActiveIndex !== option.value }"
                @click="setDateActiveIndex(option.value)"
                size="mini"
                type="primary"
              >
                {{ option.label }}
              </el-button>
            </div>
          </span>
          <el-date-picker 
            v-model="date"
            :start-placeholder="$t('date.start')"
            :end-placeholder="$t('date.end')"
            :picker-options="datePickerOptions"
            :default-time="['00:00:00']"
            @change="submit(true)"
            type="datetimerange"
            format="yyyy/MM/dd HH:mm"
            value-format="timestamp"
          />
        </div>
    
        <!-- 右側按鈕區域 -->
        <div class="right-section">
          <el-button v-if="adminRole&&!isKMRT" type="default" size="small" @click="toggleTHSRRoleAndSubmit">
            THSR模式
          </el-button>
          <el-button v-if="declRole" type="default" size="small" @click="toggleExport2Execl">
            Export To Excel
          </el-button>
        </div>
      </div>
    </el-card>

    <div class="instrument-wrapper">
      <enhanced-table 
        ref="ENHANCEDTABLE"
        :title="getTitle" 
        :showSearch="!isSimplify&&!isKMRT" 
        :rightRadioOption="isSimplify" 
        :default-radio-value="selectedRadio" 
        :table-data="filteredMessages" 
        :col-configs="getColConfigs" 
        :radio-configs="radioConfigs" 
        :isLoading="isLoading"
        :showFilterCheckBox="activeFilterEnable"
        @checkedReturn="checkedReturn"
      >
      </enhanced-table>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { isThsrProject } from '@/lib/base/project';
import EnhancedTable from '@/components/common/EnhancedTable';

export default {
  components: {
    EnhancedTable,
  },
  props: {
    // 包含原版、simplify、KMRT版本
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      useStorm: false,
      stormProject: null,
      stormUseUrl: 'https://api-thsr-rain.geosupply.com.tw/',
      isLoading: false,
      selectedRadio: '警戒值|黃燈',
      messageList: [],
      allMessageList: [],
      clientList: [],
      
      props: {
        multiple: true,
        //expandTrigger: 'hover',
        label: 'label',
        value: 'value',
        children: 'children',
      },
      datePickerOptions: {
        disabledDate(date) {
          return date > new Date();
        },
      },
      date:[
        (this.isSimplify) ? 
          this.$moment()
            .subtract(7, 'days')
            .startOf('day')
            .valueOf() : 
          (this.isKMRT) ? 
            this.$moment()
              .subtract(1, 'months')
              .startOf('day')
              .valueOf() : 
            this.$moment()
              .subtract(3, 'months')
              .startOf('day')
              .valueOf(),
        this.$moment().valueOf(),
      ],
      useDate: true,
      instruments: [],
      instrumentOptions: [],
      instrumentStations: [],
      areaList: [],

      dateActiveIndex: 2,
      pickDateList: [
        {
          label: '7D',
          value: 0,
        },
        {
          label: '1M',
          value: 1,
        },
        {
          label: '3M',
          value: 2,
        },
      ],

      activeFilterEnable: false,
      showAll: false,

      customRole: null,
      defaultRole: null,
    };
  },
  computed: {
    selectedProject() {
      return this.$store.getters['project/selectedProject'];
    },
    userRole() {
      return this.customRole ?? this.$store.getters['user/details'].roles;
    },
    isSimplify() {
      return this.type === 'simplify';
    },
    isKMRT() {
      return this.type === 'KMRT';
    },
    getTitle() {
      return this.isSimplify ? '近七日事件紀錄(藍底為暴雨系統儀器)' : null;
    },
    getColConfigs() {
      if(this.isKMRT){
        return [
          {
            label: this.$i18n.t('eventList.kmrt_area'),
            prop: 'areaName',
            'min-width': '170px',
          },
          {
            label: this.$i18n.t('eventList.kmrt_instrument'),
            prop: 'instrument',
            'min-width': '175px',
          },
          {
            label: this.$i18n.t('eventList.startTime'),
            prop: 'occurrenceDate',
            'min-width': '130px',
          },

          {
            label: this.$i18n.t('eventList.data'),
            prop: 'data',
            'min-width': '80px',
          },
          {
            label: this.$i18n.t('eventList.alert'),
            prop: 'alert_config_option',
            'min-width': '120px',
            alert_config_view: true,
          },
        ];
      }
      else{
        // 儀器編號 總量(黃燈) 速率(紅燈) 發生時間 通報狀態 通報時間 通報者
        let colConfig = [
          {
            label: this.$i18n.t('eventList.instrument'),
            prop: 'instrument',
            'min-width': '180px',
          },
          {
            label: this.$i18n.t('eventList.AL'),
            prop: 'al_value',
            'min-width': '100px',
          },
          {
            label: this.$i18n.t('eventList.WSL'),
            prop: 'wsl_value',
            'min-width': '100px',
          },
          {
            label: this.$i18n.t('eventList.startTime'),
            prop: 'occurrenceDate',
            'min-width': '260px',
          },
          {
            label: this.$i18n.t('eventList.isNotify'),
            prop: 'inform.enable',
            'min-width': '150px',
            formatter(column, row, cellValue) {
              if(!cellValue) return '未通報';
              return '已通報';
            },
          },
          {
            label: this.$i18n.t('eventList.notifyTime'),
            prop: 'inform.time',
            'min-width': '150px',
            formatter(column, row, cellValue) {
              if(!cellValue) return '';
              return moment(cellValue).format('YYYY-MM-DD HH:mm');
            },
          },
          {
            label: this.$i18n.t('eventList.notifyStaff'),
            prop: 'inform.user.name',
            'min-width': '150px',
          },
          {
            label: this.$i18n.t('eventList.chart'),
            prop: 'btnOption',
            'min-width': '80px',
            urlBtn: true,
            //block: 'chart',
          },
        ];

        // 儀器編號 (藍燈) 總量(黃燈) 速率(紅燈) 發生時間 告警內容 通報狀態 通報時間 通報者
        if(this.declRole){
          colConfig = [
            {
              label: this.$i18n.t('eventList.instrument'),
              prop: 'instrument',
              'min-width': '180px',
            },
            {
              label: this.$i18n.t('eventList.WL'),
              prop: 'wl_value',
              'min-width': '100px',
            },
            {
              label: this.$i18n.t('eventList.AL'),
              prop: 'al_value',
              'min-width': '100px',
            },
            {
              label: this.$i18n.t('eventList.WSL'),
              prop: 'wsl_value',
              'min-width': '100px',
            },
            {
              label: this.$i18n.t('eventList.startTime'),
              prop: 'occurrenceDate',
              'min-width': '260px',
            },
            //{
            //  label: this.$i18n.t('eventList.area'),
            //  prop: 'areaName',
            //  'min-width': '175px',
            //},
            {
              label: this.$i18n.t('eventList.content'),
              prop: 'content',
              'min-width': '550px',
            },
            {
              label: this.$i18n.t('eventList.isNotify'),
              prop: 'inform.enable',
              'min-width': '150px',
              formatter(column, row, cellValue) {
                if(!cellValue) return '未通報';
                return '已通報';
              },
            },
            {
              label: this.$i18n.t('eventList.notifyTime'),
              prop: 'inform.time',
              'min-width': '150px',
              formatter(column, row, cellValue) {
                if(!cellValue) return '';
                return moment(cellValue).format('YYYY-MM-DD HH:mm');
              },
            },
            {
              label: this.$i18n.t('eventList.notifyStaff'),
              prop: 'inform.user.name',
              'min-width': '150px',
            },
            {
              label: this.$i18n.t('eventList.chart'),
              prop: 'btnOption',
              'min-width': '80px',
              urlBtn: true,
              //block: 'chart',
            },
          ];
        }

        return colConfig;
      }
    },
    // 取得（或補）儀器名稱的小工具
    // 優先順序：message.instrument → message.instrument_data.data[0].name → message.instrument_id.data[0].name
    getInstrumentNameFn() {
      return (msg) => {
        const fromInstrument = (msg.instrument ?? '').toString().trim();
        if (fromInstrument) return fromInstrument;

        const fromData = msg?.instrument_data?.data?.[0]?.name;
        if (typeof fromData === 'string' && fromData.trim()) return fromData.trim();

        const fromIdObj = msg?.instrument_id?.data?.[0]?.name;
        if (typeof fromIdObj === 'string' && fromIdObj.trim()) return fromIdObj.trim();

        return ''; // 仍然取不到就視為空
      };
    },

    // 餵給表格的最終資料：先補欄位，再篩掉沒有儀器編號的
    filteredMessages() {
      return (this.messageList || [])
        .map(msg => {
          const name = this.getInstrumentNameFn(msg);
          return name && !msg.instrument
            ? { ...msg, instrument: name }  // 補上 instrument，避免後續功能需要
            : msg;
        })
        .filter(msg => {
          const name = (msg.instrument ?? '').toString().trim();
          return name.length > 0;            // 僅保留有編號/名稱者
        })
        .filter(msg=>{
          return !this.occRole || msg.instrument?.includes('TM');
        });
    },
    
    occRole() {
      return this.userRole === 'occ';
    },
    thsrRole() {
      return this.userRole === 'admin'|| this.userRole === 'thsr';
    },
    declRole() {
      return (this.userRole === 'admin'|| this.userRole === 'decl') && !this.isSimplify;
    },
    adminRole() {
      return (this.defaultRole ?? this.userRole) === 'admin';
    },

    radioConfigs() {
      let defaultConfig = [
        {
          text: this.$i18n.t('eventList.all'),
          value: '',
        },
        {
          text: this.$i18n.t('eventList.AL'),
          value: '警戒值|黃燈',
        },
        {
          text: this.$i18n.t('eventList.WSL'),
          value: '行動值|紅燈',
        },
      ];

      if(this.declRole) {
        defaultConfig.push({
          text: this.$i18n.t('eventList.WL'),
          value: '注意值|藍燈',
        });
        defaultConfig.push({
          text: this.$i18n.t('eventList.down'),
          value: '故障',
        });
      }
      return defaultConfig;
    },
  },
  mounted() {
    this.defaultRole = this.userRole;

    if(this.isKMRT) this.showAll = true;

    console.log('SMS config:', this.type, this.isSimplify, this.isKMRT);
    this.date = [
      (this.isSimplify) ? 
        this.$moment()
          .subtract(7, 'days')
          .startOf('day')
          .valueOf() : 
        (this.isKMRT) ? 
          this.$moment()
            .subtract(1, 'months')
            .startOf('day')
            .valueOf() : 
          this.$moment()
            .subtract(7, 'days')
            .startOf('day')
            .valueOf(),
      this.$moment().valueOf(),
    ];
    this.dateActiveIndex = (this.isSimplify) ? 0 : (this.isKMRT) ? 1 : 2;
    //this.activeFilterEnable = (this.isKMRT) ? true : false;
    if(isThsrProject(this.selectedProject._id) && this.thsrRole) this.useStorm = true;
    this.submit(true);
  },
  methods: {
    setStormProject() {
      if(!this.useStorm) return;
      return this.$axios({
        category: 'project',
        method: 'get',
        apiName: '',
        useUrl: this.stormUseUrl,
      })
        .then(res => {
          this.stormProject = res.data[0];
        })
        .catch(this.$notifyError);
    },
    getStormStation() {
      console.log('getStormStation');
      if(!this.useStorm){
        console.log('no storm rule');
        return;
      }
      return this.$axios({
        category: 'project',
        method: 'get',
        apiName: `${this.stormProject._id}/area-station-instrument`,
        useUrl: this.stormUseUrl,
      })
        .then(res => {
          const stationInstruments = [];
          let index = 0;
          res.data.area.forEach((area) => {
            return area.station.forEach((station) => {
              const { _id, name } = station;
              const instrument = station.instrument.map((instrument) => {
                const { _id, last_reading, display_output, status } = instrument;
                const data = instrument.latestVersion;
                index += 1;
                return {
                  _id,
                  name: data.name,
                  reading: last_reading ? `${last_reading[display_output]} ${data.unit}` : null,
                  TIMESTAMP: last_reading ? last_reading.TIMESTAMP : null,
                  coordinates: data.coordinates,
                  status,
                  index,
                };
              });
              stationInstruments.push({ _id, name, instrument });
            });
          });
          const resultList = stationInstruments.map(station => {
            const obj = {
              label: station.name,
              children: station.instrument.map(instrument => {
                const obj = {
                  label: instrument.name,
                  value: instrument.name,
                };
                return obj;
              }),
            };
            return obj;
          });
          this.instrumentStations = [...resultList];
          this.areaList = res.data.area;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getEventList() {
      this.eventList = [];
      //const instrument = this.$refs.cascader.getCheckedNodes(true)[0].value;
      const instrument = 'all';
      let [startTime, endTime] = this.date;
      console.log(this.date);
      if(!this.useStorm) {
        return;
      }
      return this.$axios({
        category: 'event',
        method: 'get',
        apiName: `/project/${this.stormProject._id}/instrument/${instrument}/alertEvent?startTime=${startTime}&endTime=${endTime}`,
        useUrl: this.stormUseUrl,
      })
        .then(res => {
          let events = res.data.map(event => {
            if (event.endTime) {
              event.occurrenceDate = `${this.$moment(event.startTime).format(
                'YYYY-MM-DD HH:mm',
              )} ~ ${this.$moment(event.endTime).format('YYYY-MM-DD HH:mm')}`;
            } else {
              event.occurrenceDate = `${this.$moment(event.startTime).format('YYYY-MM-DD HH:mm')} (進行中)`;
            }
            return event;
          });
          //this.eventList = events;
          let eventList = events.map(ele => {
            return {
              ...ele,
              instrument: ele.instrument_id.data[0].name,
              station: this.getInstrumentStation(ele.instrument_id),
              area: this.getInstrumentArea(ele.instrument_id),
              alert: this.getAlertType(ele.outputs),
            };
          }).map(ele => {
            return {
              ...ele,
              content: '-高鐵邊坡暴雨預警系統通知-\n' +
                      ` ${ele.area}分區內高鐵里程${ele.station}之雨量站
                        ${ele.instrument}
                        達${(ele.alert === 'AL') ? '黃燈' : (ele.alert === 'WSL') ? '紅燈' : '未知'}警戒
                      `,
              areaName: ele.station,
              btnOption: {
                prop: ele.instrument_id,
                urlBtn: '/storm/snake-line',
                block: 'chart',
              },
              startDate: ele.startTime,
              storm: true,
              alert_config_option: {},
            };
          }).filter(ele => {
            return ![null,undefined,NaN].includes(ele.station);
          });
          //console.log(this.eventList);
          this.messageList = this.makeMsgList(eventList);
        })
        .catch((e)=>{
          this.$notifyError(e);
          console.log(e);
        });
    },
    getInstrumentStation(instrument){
      for(let station of this.instrumentStations){
        for(let _instrument of station.children){
          if(_instrument.label === instrument.data[0].name) return station.label;
        }
      }
      return null;
    },
    getInstrumentArea(instrument){
      for(let area of this.areaList){
        for(let station of area.station){
          for(let _instrument of station.instrument){
            if(_instrument.latestVersion.name === instrument.data[0].name) return area.name;
          }
        }
      }
      return null;
    },
    getAlertType(outputs){
      const ALStandard = {
        threeHourRainFallIntercept: 25,
        oneDayRainFallIntercept: 190,
      };

      const WSLStandard = {
        threeHourRainFallIntercept: 40,
        oneDayRainFallIntercept: 285,
      };
      let result = null;
      for(let output of outputs){
        const { threeHourRainFallIntercept, oneDayRainFallIntercept } = output;
      
        if (
          threeHourRainFallIntercept > WSLStandard.threeHourRainFallIntercept ||
          oneDayRainFallIntercept > WSLStandard.oneDayRainFallIntercept
        ) {
          return 'WSL';
        } else if (
          threeHourRainFallIntercept > ALStandard.threeHourRainFallIntercept ||
          oneDayRainFallIntercept > ALStandard.oneDayRainFallIntercept
        ) {
          result = 'AL';
        }
      }
      return result;
    },
    async submit(useDate) {
      this.isLoading = true;
      this.useDate = useDate || this.isSimplify;

      if(this.useStorm) await this.setStormProject();
      this.messageList = [];
      await this.getMessage();
      if(this.useStorm) await this.getStormStation();
      this.instruments = [];
      if(this.useStorm) await this.getEventList();
      this.msgSort();
      await this.initCascaderSelector();

      let regex = /(?<type>注意值|警戒值|行動值)\s*(?<value>[+-]?\d+(?:\.\d+)?)\s*/;
      
      this.messageList = this.messageList.map(ele=>{
        let m = regex.exec(ele.content);
        let value = m?.groups.value;
        let type  = m?.groups.type;
        let inform = ele.inform;
        let unit = ele?.instrument_data?.data?.[0]?.unit ?? '';
        if(inform && inform?.user?.name) inform.enable = true;
        const valueWithUnit = `${value} ${unit}`;
        return {
          ...ele,
          inform,
          data: value,
          wl_value: type  === '注意值' ? valueWithUnit : undefined,
          al_value: type  === '警戒值' ? valueWithUnit : undefined,
          wsl_value: type === '行動值' ? valueWithUnit : undefined,
        };
      });
      this.allMessageList = this.$lodash.cloneDeep(this.messageList);
      //console.log(this.allMessageList.filter(ele=>ele.content.includes('警戒值') || ele.content.includes('行動值')));
      if(this.isKMRT)this.checkedReturn(true);
      this.isLoading = false;
      console.log(this.allMessageList);
      console.log(this.messageList);
      console.log(this.filteredMessages);
      this.$emit('componentMounted');
    },
    initCascaderSelector() {
      this.instrumentOptions = [];
      this.instruments = [];
      this.dataList = [];
      return this.$axios({
        category: 'project',
        method: 'get',
        apiName: `${this.selectedProject._id}/area-station-instrument`,
      })
        .then(res => {
          let instrumentOptions = res.data.area.map(area => {
            const obj = {
              label: area.name,
              disabled: area.station.length === 0,
              children: area.station.map(station => {
                const obj = {
                  label: station.name,
                  disabled: station.instrument.length === 0,
                  children: station.instrument.map(instrument => {
                    const obj = {
                      label: instrument.latestVersion.name,
                      value: instrument.latestVersion.name,
                    };
                    return obj;
                  }),
                };
                return obj;
              }),
            };
            return obj;
          });
          
          //console.log(instrumentOptions);
          //console.log(this.instrumentStations);
          if(this.useStorm) this.instrumentOptions = [ 
            {
              label: 'rain',
              disabled: false,
              children: this.instrumentStations,
            }, ...instrumentOptions];
          else this.instrumentOptions = [ ...instrumentOptions];
        })
        .catch(error => {
          console.log(error);
          this.$notifyError(this.$t('chart.error.loading'), error.response.data.message);
        });
    },
    getCascaderInstrumentList() {
      if(this.instruments.length==0){
        this.messageList = this.$lodash.cloneDeep(this.allMessageList);
        return;
      }
      const usedInstruments = this.instruments.map(ele => ele[2]);
      this.messageList = this.allMessageList.filter(ele=>{
        return usedInstruments.includes(ele.instrument);
      });
      console.log(this.messageList);
    },
    handleCurrentChange(page) {
      this.currentPage = page;
    },
    getMessage() {
      console.log(this.date);

      if(!this.useDate){
        const apiName = (this.declRole)? `${this.selectedProject._id}/getAlertsList/limit` : `${this.selectedProject._id}/getAlertsList/limit?withoutdown=true`;
        return this.$axios({
          category: 'alerts',
          method: 'get',
          apiName,
        })
          .then(res => {
            let data = res.data.map(ele=>{
              return {
                ...ele,
                startDate: moment(ele.startTime).format('YYYY-MM-DD HH:mm'),
                areaName: ele.area,
                btnOption: {
                  prop: ele.instrumentId,
                  urlBtn: 'chart',
                  block: 'chart',
                },
                occurrenceDate: moment(ele.startTime).format('YYYY-MM-DD HH:mm'),
                alert_config_option: this.getAlertConfigOption(ele.instrument_data, ele.alert_type, ele.rate),
              };
            });
            this.messageList = this.makeMsgList(data);
          })
          .catch((error)=>{
            this.$notifyError(error);
            console.log(error);
          });
      }
      else{
        const apiName = (this.declRole)? `${this.selectedProject._id}/getAlertsList/${new Date(Number(this.date[0]))}&${new Date(Number(this.date[1]))}` : `${this.selectedProject._id}/getAlertsList/${new Date(Number(this.date[0]))}&${new Date(Number(this.date[1]))}?withoutdown=true`;
        return this.$axios({
          category: 'alerts',
          method: 'get',
          apiName,
        })
          .then(res => {
            let data = res.data.map(ele=>{
              return {
                ...ele,
                startDate: moment(ele.startTime).format('YYYY-MM-DD HH:mm'),
                areaName: ele.area,
                btnOption: {
                  prop: ele.instrumentId,
                  urlBtn: 'chart',
                  block: 'chart',
                },
                occurrenceDate: ele.startTime,
                alert_config_option: this.getAlertConfigOption(ele.instrument_data, ele.alert_type, ele.rate),
              };
            });
            this.messageList = this.makeMsgList(data);
          })
          .catch((error)=>{
            this.$notifyError(error);
            console.log(error);
          });
      }
    },
    msgSort(){
      this.messageList = this.messageList.sort((a,b)=>{
        return new Date(b.startDate).getTime() - new Date(a.startDate).getTime();
      });
    },
    getAlertConfigOption(instrument_data, alert_type, rate_type){
      let data = instrument_data?.data[0];
      if(!data) return {};

      if(rate_type) {
        const rateObj = data && data[rate_type] ? data[rate_type] : null;

        const plus_rate  = rateObj ? rateObj[`${alert_type}_plus`]  ?? null : null;
        const minus_rate = rateObj ? rateObj[`${alert_type}_minus`] ?? null : null;
        
        return {
          value: (plus_rate && minus_rate) ? `${plus_rate}/${minus_rate}` : ((plus_rate) ? plus_rate : ((minus_rate) ? minus_rate : '')),
          alert_type,
        };
      }
      let plus  = data[`${alert_type}_plus` ];
      let minus = data[`${alert_type}_minus`];
      return {
        value: (plus && minus) ? `${plus}/${minus}` : ((plus) ? plus : ((minus) ? minus : '')),
        alert_type,
      };
    },
    makeMsgList(data){
      //console.log('test');
      //console.log(this.messageList);
      //console.log(data);
      return [...this.messageList,...data];
    },
    setDateActiveIndex(index) {
      this.dateActiveIndex = index;
      const now = this.$moment();
      const start = now.clone()                 // 用 clone 避免改到 now
        .subtract([7, 1, 3][index], index === 0 ? 'days' : 'months')
        .startOf('day')
        .valueOf();                             // 直接拿毫秒數

      this.date = [start, now.valueOf()];
      this.submit(true);
    },

    checkedReturn(checked){
      console.log('checkedReturn',checked);
      this.showAll = checked;
      if(this.showAll) {
        this.getCascaderInstrumentList();
        return;
      }
      //'checkedReturn';
      console.log(this.allMessageList);
      let newMsgList = Array.from(this.allMessageList.filter(
        ele=>{
          const isAlertNow = ele.instrument_data.status ==='WSL' || ele.instrument_data.status ==='AL' || ele.instrument_data.status ==='WL';
          return isAlertNow;
        },
      ).reduce(
        (map, ev)=>{
          const id = ev.instrument_data._id;
          const prev = map.get(id);
          if (!prev || new Date(ev.occurrenceDate) > new Date(prev.occurrenceDate)) {
            map.set(id, ev);
          }
          return map;
        }, new Map(),
      ).values());

      console.log(newMsgList);
      this.messageList = newMsgList;
    },

    toggleTHSRRoleAndSubmit(){
      console.log('toggleTHSRRoleAndSubmit');
      if(!this.customRole ||this.customRole == 'admin') this.customRole = 'thsr';
      else if(this.customRole == 'thsr') this.customRole = 'admin';
      console.log('SMS config:', this.type, this.isSimplify, this.isKMRT);
      this.date = [
        (this.isSimplify) ? 
          this.$moment()
            .subtract(7, 'days')
            .startOf('day')
            .valueOf() : 
          (this.isKMRT) ? 
            this.$moment()
              .subtract(1, 'months')
              .startOf('day')
              .valueOf() : 
            this.$moment()
              .subtract(3, 'months')
              .startOf('day')
              .valueOf(),
        this.$moment().valueOf(),
      ];
      this.dateActiveIndex = (this.isSimplify) ? 0 : (this.isKMRT) ? 1 : 2;
      //this.activeFilterEnable = (this.isKMRT) ? true : false;
      if(isThsrProject(this.selectedProject._id) && this.thsrRole) this.useStorm = true;
      this.submit(true);
    },

    async toggleExport2Execl(){
      try {
        // 準備資料
        //console.log(this.filteredMessages);
        //console.log(this.$refs.ENHANCEDTABLE.filteredTableData);
        const exportData = this.$refs.ENHANCEDTABLE.filteredTableData.map(msg => {
          const row = {
            '儀器編號': msg.instrument || '',
            '發生時間': msg.occurrenceDate || '',
          };

          if (this.isKMRT) {
            row['區域'] = msg.areaName || '';
            row['數據'] = msg.data || '';
            row['警戒類型'] = msg.alert_config_option?.alert_type || '';
          } else {
            if (this.declRole) {
              row['注意值(藍燈)'] = msg.wl_value || '';
            }
            row['警戒值(黃燈)'] = msg.al_value || '';
            row['行動值(紅燈)'] = msg.wsl_value || '';

            if (this.declRole) {
              row['告警內容'] = msg.content || '';
            }

            row['通報狀態'] = msg.inform?.enable ? '已通報' : '未通報';
            row['通報時間'] = msg.inform?.time ? moment(msg.inform.time).format('YYYY-MM-DD HH:mm') : '';
            row['通報人員'] = msg.inform?.user?.name || '';
          }

          return row;
        });

        if (exportData.length === 0) {
          this.$message.warning('沒有資料可以匯出');
          return;
        }

        // 轉換為 CSV
        const headers = Object.keys(exportData[0]);
        const csvContent = [
          // UTF-8 BOM (讓 Excel 正確識別中文)
          '\ufeff',
          // 標題行
          headers.join(','),
          // 資料行
          ...exportData.map(row => 
            headers.map(header => {
              const value = row[header] || '';
              // 如果包含逗號或換行，需要用引號包起來
              return value.includes(',') || value.includes('\n') 
                ? `"${value.replace(/"/g, '""')}"` 
                : value;
            }).join(','),
          ),
        ].join('\n');

        // 建立下載連結
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        const startDate = moment(this.date[0]).format('YYYYMMDD');
        const endDate = moment(this.date[1]).format('YYYYMMDD');

        link.setAttribute('href', url);
        link.setAttribute('download', `告警紀錄_${startDate}_${endDate}.csv`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.$message.success('匯出成功');
      } catch (error) {
        console.error('匯出失敗:', error);
        this.$message.error('匯出失敗，請稍後再試');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.instrument-wrapper {
  /* 用 flex-column 讓分頁直接貼在表格下方 */
  display: flex;
  flex-direction: column;
}

.card-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px; /* 左右區域之間的間距 */
}

.left-section {
  display: flex;
  align-items: center;
  gap: 12px; /* 左側組件之間的間距 */
  flex: 1; /* 讓左側區域佔據可用空間 */
  flex-wrap: wrap; /* 如果空間不夠，允許換行 */
}

.right-section {
  display: flex;
  align-items: center;
  gap: 8px; /* 按鈕之間的間距 */
  flex-shrink: 0; /* 防止按鈕被壓縮 */
}

/* 響應式設計：小螢幕時換行 */
@media (max-width: 768px) {
  .card-content {
    flex-direction: column;
    align-items: stretch;
  }
  
  .right-section {
    justify-content: flex-end;
    margin-top: 12px;
  }
}
</style>